module.exports = __webpack_public_path__ + "media/images/area/icon_weather_18-d2ffdafc83ecc01afe1f4ee461251e59.png";